import React from 'react';
import { GlobalStylesUTCom as GlobalStyles } from '../styles/Global';
import { Footer } from '../Footer';
import { HeaderContainer, Wrapper, mainContent, Title } from './styles';
import { Box, TypographyTitleProps } from '@utex/ui-kit';

interface Props {
  helmet?: JSX.Element;
  header: JSX.Element;
  sideMenu?: JSX.Element;
  tabbar: JSX.Element;
  title?: string;
  titleSize?: TypographyTitleProps['size'];
  phonabletTitle?: string;
}

export const Layout: React.FC<Props> = props => {
  return (
    <>
      {props.helmet}
      <GlobalStyles />

      <HeaderContainer>{props.header}</HeaderContainer>
      {props.sideMenu}

      <Wrapper as="main" css={mainContent}>
        {props.title && (
          <Box display={{ phonablet: props.phonabletTitle ? 'none' : undefined }}>
            <Title size={props.titleSize}>{props.title}</Title>
          </Box>
        )}

        {props.phonabletTitle && (
          <Box display={{ all: 'none', phonablet: props.phonabletTitle ? 'block' : undefined }}>
            <Title>{props.phonabletTitle}</Title>
          </Box>
        )}

        {props.children}
      </Wrapper>

      <Wrapper>
        <Footer />
      </Wrapper>

      {props.tabbar}
    </>
  );
};
